// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias
import Vue from 'vue';
import ElementUI from 'element-ui';
// import VCharts from 'v-charts';
import Clipboard from 'v-clipboard';
import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css/normalize.css';
import animated from 'animate.css';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import App from './App';
import router from './router';
import mbt from './assets/js/mbt';
import store from './store';
/* eslint-disable */
import '../static/ueditor/ueditor.parse.min.js';

import '../static/css/reset.css';
import './assets/css/common.css';
import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import '@/utils/globalData'
import '@/utils/wwLogin-1.0.0.js';
ElementUI.Table.props.border = {type:Boolean, default: true}
Vue.use(VideoPlayer)

// console.log(process.env.NODE_ENV, 'main');
require('es6-promise').polyfill();

Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999,
    },
});
Vue.use(ElementUI);
// Vue.use(VCharts);
Vue.use(animated);
Vue.use(mbt);
Vue.use(Clipboard);

Viewer.setDefaults({
    zIndexInline: 9999,
    Options: {
        zIndex: 9999,
    },
});

Vue.config.productionTip = true;
// Vue.config.productionTip = false;

/* eslint-disable no-new */

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js